import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CheckCircle2, Star } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'El Protocolo de Sincronización de 72 Horas',
    desc: 'El paso a paso para resetear el reloj biológico de tu hogar este mismo fin de semana.'
  }, {
    title: 'Método de Intervención Gentil',
    desc: 'Cómo calmar los despertares nocturnos en 5 minutos sin traumas ni llantos interminables.'
  }, {
    title: 'Manual de Supervivencia en la Oficina',
    desc: "La técnica 'Nap-a-Latte' y el sistema de bloques 90/15 para rendir al máximo con poco sueño."
  }, {
    title: 'Guía de Blindaje del Ambiente',
    desc: 'Ajustes térmicos y lumínicos exactos para convertir su habitación en una cápsula de sueño profundo.'
  }];
  return <div className="bg-cream text-navy" data-id="element-208">
      <SectionWrapper data-id="element-209">
        <div className="max-w-4xl mx-auto" data-id="element-210">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-16" data-id="element-211">
            Lo que obtienes hoy
          </h2>

          <div className="space-y-6 mb-12" data-id="element-212">
            {items.map((item, index) => <div key={index} className="flex items-start bg-white p-6 md:p-8 rounded-sm shadow-sm border border-navy/5" data-id="element-213">
                <CheckCircle2 className="text-gold shrink-0 mt-1 mr-6" size={28} data-id="element-214" />
                <div data-id="element-215">
                  <h3 className="text-xl font-serif font-bold mb-2" data-id="element-216">
                    {item.title}
                  </h3>
                  <p className="text-lg font-sans text-navy/70" data-id="element-217">{item.desc}</p>
                </div>
              </div>)}
          </div>

          {/* Bonus Item */}
          <div className="relative bg-navy text-cream p-8 md:p-10 rounded-sm shadow-xl border border-gold/30 mt-12 overflow-hidden" data-id="element-218">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/10 rounded-bl-full pointer-events-none" data-id="element-219"></div>
            <div className="flex items-start relative z-10" data-id="element-220">
              <Star className="text-gold shrink-0 mt-1 mr-6 fill-gold" size={32} data-id="element-221" />
              <div data-id="element-222">
                <div className="text-gold font-bold tracking-widest uppercase text-sm mb-2" data-id="element-223">
                  Bonus Exclusivo
                </div>
                <h3 className="text-2xl font-serif text-white mb-3" data-id="element-224">
                  Plantilla de comunicación para jefes y equipos
                </h3>
                <p className="text-lg font-sans text-cream/80" data-id="element-225">
                  Los guiones exactos sobre cómo pedir flexibilidad o comunicar
                  tu situación sin parecer incompetente ni poner en riesgo tu
                  posición.
                </p>
              </div>
            </div>
          </div>
        </div>
      </SectionWrapper>
    </div>;
}